<template>
  <div ref="wrapper">
    <div class="content">
      <div v-if="pulldown">
        <div class="top-tip">
          <div class="">{{dragTip.text}}</div>
        </div>
      </div>
      <slot></slot>
    </div>
    <slot name="AZ"></slot>
    <slot name="search"></slot>
  </div>
</template>

<script type="text/ecmascript-6">
import BScroll from "better-scroll";

export default {
  props: {
    /**
     * 1 滚动的时候会派发scroll事件，会截流。
     * 2 滚动的时候实时派发scroll事件，不会截流。
     * 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
     */
    probeType: {
      type: Number,
      default: 1
    },
    /**
     * 点击列表是否派发click事件
     */
    click: {
      type: Boolean,
      default: true
    },
    /**
     * 是否开启横向滚动
     */
    scrollX: {
      type: Boolean,
      default: false
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    data: {
      default: () => []
    },
    /**
     * 是否派发滚动到底部的事件，用于上拉加载
     */
    pullup: {
      type: Boolean,
      default: false
    },
    /**
     * 是否派发顶部下拉的事件，用于下拉刷新
     */
    pulldown: {
      type: Boolean,
      default: false
    },
    /**
     * 是否派发列表滚动开始的事件
     */
    beforeScroll: {
      type: Boolean,
      default: false
    },
    /**
     * 当数据更新后，刷新scroll的延时。
     */
    refreshDelay: {
      type: Number,
      default: 20
    },
    /**
     * 下拉是否回弹
     */
    bounce: {
      type: Boolean,
      default: true
    },
    /**
     * 回弹动画效果 时间
     */
    bounceTime: {
      type: Number,
      default: 500
    },
    swipeTime: {
      type: Number,
      default: 1500
    }
  },
  data() {
    return {
      dragTip: {
        text: "下拉刷新",
        translate: -50,
        showLoding: false
      },
      isLoading: false,
      isDone: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this._initScroll();
    });
  },
  methods: {
    _initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        bounce: this.bounce,
        bounceTime: this.bounceTime,
        swipeTime: this.swipeTime
      });

      if (this.listenScroll) {
        let me = this;
        this.scroll.on("scroll", pos => {
          me.$emit("scroll", pos);
        });
      }

      if (this.pullup) {
        this.scroll.on("scrollEnd", () => {
          if (this.scroll.y <= this.scroll.maxScrollY + 50) {
            this.$emit("scrollToEnd");
          }
        });
      }
      if (this.pulldown) {
        this.scroll.on("scroll", pos => {
          //显示下拉刷新loding
          if (pos.y > 50) {
            this.dragTip.text = "释放刷新";
          }
        });
        this.scroll.on("touchEnd", pos => {
          if (pos.y > 50) {
            this.dragTip.text = "刷新中...";
            //重新初始化
            this.$on("finishLoad", this.resetParams);
            this.$emit("pulldown", pos);
          }
        });
      }

      if (this.beforeScroll) {
        this.scroll.on("beforeScrollStart", () => {
          this.$emit("beforeScroll");
        });
      }
    },
    resetParams() {
      setTimeout(() => {
        this.isLoading = false;
        this.isDone = false;
        this.dragTip = {
          text: "下拉刷新",
          translate: -50,
          showLoding: false
        };
      }, 600);
    },
    disable() {
      this.scroll && this.scroll.disable();
    },
    enable() {
      this.scroll && this.scroll.enable();
    },
    refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  watch: {
    data() {
      setTimeout(() => {
        this.refresh();
      }, this.refreshDelay);
    }
  }
};
</script>

<style scoped lang="less" >
.pulldown,
.pullup {
  width: 100%;
  height: 50px;
  position: relative;
}

.top-tip {
  position: absolute;
  top: -50px;
  width:100%;
  height: 50px;
  font-size: 12px;
  text-align: center;
  // transform: translate(-50%, 0);
}

.list-donetip {
  text-align: center;
  line-height: 50px;
  font-size: 0.28rem;
}
.content{
  position: relative;
}
</style>
